import React, { useState, useEffect } from 'react'
import axios from 'axios'
import {Link, useHistory } from 'react-router-dom'

function VeloEdit(props) {
  const [loading, setLoading] = useState(true)
  const [users, setUsers] = useState([]) 
  const history = useHistory()
  const [velo, setVelo] = useState({
    user_id:'',
    type:'',
    marque:'',
    modele:'',
    taille:'',
    cadre:'',
    fourche:'',
    boitier_pedalier:'',
    pedalier:'',
    pedale:'',
    chaine:'',
    cassette:'',
    amortisseur:'',
    derailleur_av:'',
    derailleur_ar:'',
    manette:'',
    frein:'',
    jeu_direction:'',
    potence:'',
    tige_selle:'',
    selle:'',
    collier_selle:'',
    poigne:'',
    moyeu_av:'',
    moyeu_ar:'',
    jante:'',
    rayon:'',
    pneu_av:'',
    pneu_ar:'',
    moteur:'',
    batterie:'',
    chargeur:'',
    ecran:'',
    couleur:'',
  })

  const id = props.match.params.id

  useEffect(() => {
    fetch()
    fetchdata(id)
  }, [id])

  const fetchdata = (id) => {
    axios.get(`/api/veloedit/${id}`).then(res => {
      setVelo(res.data.velo)
      setLoading(false)
    })
  }

  const fetch = () => {
    axios.get('/api/clientlistprevision').then(res => {
      setUsers(res.data.client)
    })
  }

  const clientlist = users.map(user => 
    <option className='text-capitalize' key={user.id} value={user.id}>{user.nom} {user.prenom}</option>
    )

  const handleInput = (e) => {
    e.persist()
    setVelo({...velo, [e.target.name]: e.target.value })
  }

  const veloSubmit = (e) => {
    const id = props.match.params.id
    e.preventDefault()
    setLoading(true)
    const data = {
      user_id: velo.user_id,
      type: velo.type,
      marque: velo.marque,
      modele: velo.modele,
      taille: velo.taille,
      cadre: velo.cadre,
      amortisseur: velo.amortisseur,
      fourche: velo.fourche,
      boitier_pedalier: velo.boitier_pedalier,
      pedalier: velo.pedalier,
      pedale: velo.pedale,
      chaine: velo.chaine,
      cassette: velo.cassette,
      derailleur_av: velo.derailleur_av,
      derailleur_ar: velo.derailleur_ar,
      manette: velo.manette,
      frein: velo.frein,
      jeu_direction: velo.jeu_direction,
      potence: velo.potence,
      tige_selle: velo.tige_selle,
      selle: velo.selle,
      collier_selle: velo.collier_selle,
      poigne: velo.poigne,
      moyeu_av: velo.moyeu_av,
      moyeu_ar: velo.moyeu_ar,
      jante: velo.jante,
      rayon: velo.rayon,
      pneu_av: velo.pneu_av,
      pneu_ar: velo.pneu_ar,
      moteur: velo.moteur,
      batterie: velo.batterie,
      chargeur: velo.chargeur,
      ecran: velo.ecran,
      couleur: velo.couleur,
    }
    axios.put(`/api/veloupdate/${id}`, data).then(res => {
      if(res.data.status === 200){
        setLoading(false)
        history.push('/admin101/velo')
      } else {
        setVelo({...velo, error: res.data.errors})
        setLoading(false)
      }
    })
  }

  if(loading){
    return (
      <div className="d-flex justify-content-center container py-5">
        <div className="spinner-border text-success my-5" role='status'></div>
      </div>
    )
  }

  return (
    <div className='container mt-5'>
      <div className="card">
        <div className="card-header text-capitalize h4">ajout vélo</div>
        <div className="card-body">
          <form className='form-group' onSubmit={veloSubmit}>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <select name="user_id" className="form-select text-capitalize" value={velo.user_id} onChange={handleInput}>
                  <option value="" className='text-capitalize'>propriétaire</option>
                  {clientlist}
                </select>
              </div>
              <div className="col-md form-group">
                <input type="text" name='type' className="form-control" placeholder="Type" onChange={handleInput} value={velo.type} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='marque' className="form-control" placeholder="Marque" onChange={handleInput} value={velo.marque} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='modele' className="form-control" placeholder="Modele" onChange={handleInput} value={velo.modele} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='taille' className="form-control" placeholder="Taille" onChange={handleInput} value={velo.taille} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='couleur' className="form-control" placeholder="Couleur" onChange={handleInput} value={velo.couleur} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='cadre' className="form-control" placeholder="Cadre" onChange={handleInput} value={velo.cadre} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='amortisseur' className="form-control" placeholder="Amortisseur" onChange={handleInput} value={velo.amortisseur} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='fourche' className="form-control" placeholder="Fourche" onChange={handleInput} value={velo.fourche} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='boitier_pedalier' className="form-control" placeholder="Boîtier pédalier" onChange={handleInput} value={velo.boitier_pedalier} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='pedalier' className="form-control" placeholder="Pédalier" onChange={handleInput} value={velo.pedalier} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='pedale' className="form-control" placeholder="Pédale" onChange={handleInput} value={velo.pedale} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='chaine' className="form-control" placeholder="Chaine" onChange={handleInput} value={velo.chaine} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='cassette' className="form-control" placeholder="Cassette" onChange={handleInput} value={velo.cassette} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='derailleur_av' className="form-control" placeholder="Dérailleur avant" onChange={handleInput} value={velo.derailleur_av} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='derailleur_ar' className="form-control" placeholder="Dérailleur arrière" onChange={handleInput} value={velo.derailleur_ar} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='manette' className="form-control" placeholder="Manette" onChange={handleInput} value={velo.manette} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='frein' className="form-control" placeholder="Frein" onChange={handleInput} value={velo.frein} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='jeu_direction' className="form-control" placeholder="Jeu de direction" onChange={handleInput} value={velo.jeu_direction} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='potence' className="form-control" placeholder="Potence" onChange={handleInput} value={velo.potence} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='tige_selle' className="form-control" placeholder="Tige de selle" onChange={handleInput} value={velo.tige_selle} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='selle' className="form-control" placeholder="Selle" onChange={handleInput} value={velo.selle} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='collier_selle' className="form-control" placeholder="Collier de selle" onChange={handleInput} value={velo.collier_selle} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='poigne' className="form-control" placeholder="Poignés" onChange={handleInput} value={velo.poigne} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='moyeu_av' className="form-control" placeholder="Moyeu avant" onChange={handleInput} value={velo.moyeu_av} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='moyeu_ar' className="form-control" placeholder="Moyeu arrière" onChange={handleInput} value={velo.moyeu_ar} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='jante' className="form-control" placeholder="Jante" onChange={handleInput} value={velo.jante} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='rayon' className="form-control" placeholder="Rayon" onChange={handleInput} value={velo.rayon} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='pneu_av' className="form-control" placeholder="Pneu avant" onChange={handleInput} value={velo.pneu_av} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='pneu_ar' className="form-control" placeholder="Pneu arrière" onChange={handleInput} value={velo.pneu_ar} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='moteur' className="form-control" placeholder="Moteur" onChange={handleInput} value={velo.moteur} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='batterie' className="form-control" placeholder="Battérie" onChange={handleInput} value={velo.batterie} />
              </div>
            </div>
            <div className="row mb-3 form-group">
              <div className="col-md form-group">
                <input type="text" name='chargeur' className="form-control" placeholder="Chargeur" onChange={handleInput} value={velo.chargeur} />
              </div>
              <div className="col-md form-group">
                <input type="text" name='ecran' className="form-control" placeholder="Ecran" onChange={handleInput} value={velo.ecran} />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-auto">
                <button type='submit' className="border rounded-pill text-capitalize btn btn-outline-primary">modifier</button>
              </div>
              <div className="col-auto">
                <Link to='/admin101/velo' className='text-capitalize btn btn-outline-secondary border rounded-pill'>annuler</Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default VeloEdit